<template>
	<div class="section-warehouse" id="warehouse">
		<h2 class="title-warehouse">TIENDA VIRTUAL:</h2>
		<p class="sub-title">VENDER POR INTERNET NUNCA FUE TAN FACIL</p>
		<v-layout wrap class="wrapper-text-desktop">
			<v-flex xs5>
				<div>
					<h2 class="text-title">¡El poder de transformar las ventas de tu empresa está en tus manos! </h2>
					<p class="text-p">Tu negocio ahora podrá tener su propia App,  la cual es completamente personalizable, 
						desde su administrador web. </p>
				</div>
				<div>
					<h2 class="text-title">¡Acepta todas las formas de pago!</h2>
					<p class="text-p">Deposito bancario, pago contra-entrega, además intégrate con todos 
						los botones de pago y acepta todas las tarjetas de crédito. </p>
				</div>
				<div>
					<h2 class="text-title">¡Optimiza tu porcentaje de conversión en tu tienda virtual!</h2>
					<p class="text-p">Analiza la experiencia de usuario de todos tus clientes, un servicio personalizado y compras flexibles. </p>
				</div>
			</v-flex>
			<v-flex xs7>
				<img src="/static/img/laptop-cel.png" alt="phone" width="100%">
			</v-flex>
		</v-layout>
		<v-layout wrap class="wrapper-text-mobile">
			<v-flex xs12 class="pr-7">
				<h2 class="text-title">¡El poder de transformar las ventas de tu empresa está en tus manos! </h2>
				<p class="text-p">Tu negocio ahora podrá tener su propia App,  la cual es completamente personalizable, 
					desde su administrador web. </p>
			</v-flex>
			<v-flex xs12>
				<v-layout>
					<v-flex xs9>
						<div>
							<h2 class="text-title">¡Acepta todas las formas de pago!</h2>
							<p class="text-p">Deposito bancario, pago contra-entrega, además intégrate con todos 
								los botones de pago y acepta todas las tarjetas de crédito. </p>
						</div>
						<div>
							<h2 class="text-title">¡Optimiza tu porcentaje de conversión en tu tienda virtual!</h2>
							<p class="text-p">Analiza la experiencia de usuario de todos tus clientes, un servicio personalizado y compras flexibles. </p>
						</div>
					</v-flex>
					<v-flex xs3>
						<img src="/static/img/telefonos.png" alt="phone" height="100%">
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="center">
			<a class="btn-section" href="#footer">SOLICITA MÁS INFORMACIÓN</a>
		</div>
	</div>
</template>
<script>
export default {
	name: 'section-warehouse',
};
</script>
<style lang="scss" scoped>
	.section-warehouse {
		background: color(title-green);
		color: color(white);
		font-family: font(lato-regular);
		font-size: 14px;
		padding: 28px 7% 39px 7%;

		@media (max-width: 936px) {
			overflow: hidden;
			padding: 28px 0 39px 7%;
		}

		.title-warehouse {
			font-family: font(lato-regular);
			font-weight: 600;
			font-size: 32px;
			text-align: center;

			@media (max-width: 936px) {
				font-size: 20px;
				padding-right: 7%;
			}
		}

		.sub-title {
			font-size: 24px;
			text-align: center;
			margin-bottom: 30px;

			@media (max-width: 936px) {
				font-size: 20px;
				padding-right: 7%;
			}
		}

		.text-title {
			font-size: 18px;
			font-family: font(lato-regular);
			font-weight: 600;
			margin-bottom: 15px;

			@media (max-width: 936px) {
				text-align: center;
			}
		}

		.text-p {
			margin-bottom: 30px;

			@media (max-width: 936px) {
				text-align: center;
			}
		}

		.btn-section {
			background: color(green-link);
			border-radius: 20px;
			color: color(white);
			font-family: font(lato-regular);
			font-weight: 600;
			margin-top: 20px;
			padding: 10px 46px;
			text-decoration: none;
		}

		.center {
			text-align: center;

			@media (max-width: 936px) {
				display: none;
			}
		}

		.wrapper-text-desktop {
			@media (max-width: 936px) {
				display: none;
			}
		}

		.wrapper-text-mobile {
			display: none;

			@media (max-width: 936px) {
				display: block;
			}
		}

		.pr-7 {
			padding-right: 7%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-warehouse.vue